import { Component } from 'react';
import Pagination from 'react-bootstrap/Pagination';

export default class Paging extends Component {

    page(pageNumber, active) {
        return active?
            <Pagination.Item key={pageNumber} active>{pageNumber}</Pagination.Item> :
            <Pagination.Item key={pageNumber} onClick={() => this.setPage(pageNumber)}>{pageNumber}</Pagination.Item>;
    }
    setPage(pageNumber) {
        if(pageNumber >= 1 && pageNumber <= this.props.pageCount && pageNumber !== this.props.pageNumber)
            this.props.setPage(pageNumber);
    }
    render() {
        return (
            <Pagination onSelect={pageNumber => this.setPage(pageNumber)}>
                <Pagination.First key={'first'} onClick={() => this.setPage(1)}/>
                <Pagination.Prev key={'prev'} onClick={() => this.setPage(this.props.pageNumber - 1)}/>
                {
                    (() => {
                        let pages = [];
                        if(this.props.pageNumber > 1 + this.props.pageRange)
                            pages.push(this.page(1));
                        if(this.props.pageNumber > 2 + this.props.pageRange)
                            pages.push(<Pagination.Ellipsis key={'back_ellipses'} />);

                        for(let i = Math.max(1, this.props.pageNumber - this.props.pageRange); i <= Math.min(this.props.pageCount, this.props.pageNumber + this.props.pageRange); i++)
                            pages.push(this.page(i, i === this.props.pageNumber));

                        if(this.props.pageNumber < this.props.pageCount - this.props.pageRange - 1)
                            pages.push(<Pagination.Ellipsis  key={'front_ellipses'} />);
                        if(this.props.pageNumber < this.props.pageCount - this.props.pageRange)
                            pages.push(this.page(this.props.pageCount));
                        return pages;
                    })()
                }
                <Pagination.Next key={'next'} onClick={() => this.setPage(this.props.pageNumber + 1)}/>
                <Pagination.Last key={'last'} onClick={() => this.setPage(this.props.pageCount)}/>
            </Pagination>
        );
    }
}